(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.priceEl = this.querySelector('.cs-sticky-atc__price');
      this.button = this.querySelector('[data-sticky-submit]');
      this.button.addEventListener('click', () => {
        const realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (realButton && !realButton.disabled) realButton.click();
      });

      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.onMediaChange = this.onMediaChange.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);
      if (this.mediaQuery.matches) this.init();
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.onMediaChange);
      this.teardown();
    }

    onMediaChange(event) {
      if (event.matches) {
        this.init();
      } else {
        this.teardown();
      }
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.sync();
      this.observeInfo();
      this.observeTarget();
    }

    teardown() {
      this.initialized = false;
      this.classList.remove('is-visible');
      if (this.infoObserver) this.infoObserver.disconnect();
      if (this.targetObserver) this.targetObserver.disconnect();
    }

    sync() {
      const info = document.getElementById(`ProductInfo-${this.sectionId}`);
      if (!info) return;

      const realPrice = info.querySelector(`#price-${this.sectionId}`);
      if (realPrice) this.priceEl.innerHTML = realPrice.innerHTML;

      const realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      if (realButton) {
        this.button.disabled = realButton.disabled;
        const label = realButton.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();
      }
    }

    observeInfo() {
      const info = document.getElementById(`ProductInfo-${this.sectionId}`);
      if (!info) return;
      this.infoObserver = new MutationObserver(() => {
        this.sync();
        this.observeTarget();
      });
      this.infoObserver.observe(info, { childList: true, subtree: true, attributes: true });
    }

    observeTarget() {
      const target = document.getElementById(`ProductBuyButtons-${this.sectionId}`);
      if (!target || target === this.observedTarget) return;

      if (this.targetObserver) this.targetObserver.disconnect();
      this.observedTarget = target;
      this.targetObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
        },
        { threshold: 0 }
      );
      this.targetObserver.observe(target);
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
  } catch(e) { console.error(e); }
})();

})();
